export default "__VITE_ASSET__9ef0ee03__"